import './index.css'
import './i18n'

import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { ChakraProvider } from '@chakra-ui/react'
import * as Sentry from '@sentry/react'
import { PersistGate } from 'redux-persist/integration/react'

import AmCustomRouter from '@/components/atoms/Routing/AmCustomRouter'
import history from '@/history'
import { persistor, store } from '@/redux/store'
import theme from '@/theme'
import App from './App'
import { LegalConsentProvider } from './contexts/legalConsent'

const environment = import.meta.env.MODE || 'development'

Sentry.init({
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  environment,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/clinicdev\.allimb\.com/,
    /^https:\/\/clinic\.allimb\.com/
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ChakraProvider theme={theme}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AmCustomRouter history={history}>
          <Suspense fallback={<></>}>
            <LegalConsentProvider>
              <App />
            </LegalConsentProvider>
          </Suspense>
        </AmCustomRouter>
      </PersistGate>
    </Provider>
  </ChakraProvider>
)
